import { render, staticRenderFns } from "./papers copy.vue?vue&type=template&id=12bc3dcf&"
import script from "./papers copy.vue?vue&type=script&lang=js&"
export * from "./papers copy.vue?vue&type=script&lang=js&"
import style0 from "./papers copy.vue?vue&type=style&index=0&id=12bc3dcf&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports